/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TimecodeInputs */



/**
* | output |
* | --- |
* | "Timecode" |
*
* @param {TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode = /** @type {((inputs?: TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code temporel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice temporale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Временной код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de tempo")
	return /** @type {LocalizedString} */ ("Timecode")
});